import { render } from "./VendorPerformanceDetail.vue?vue&type=template&id=3c8942b5"
import script from "./VendorPerformanceDetail.vue?vue&type=script&lang=js"
export * from "./VendorPerformanceDetail.vue?vue&type=script&lang=js"
script.render = render

export default script